import { render, staticRenderFns } from "./PluginLayout.vue?vue&type=template&id=60485e8b"
import script from "./PluginLayout.vue?vue&type=script&lang=js"
export * from "./PluginLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports